import http from '../_http'

const mail = {
  //default
  commonMail : (m) => { return http.post(`common/mail`, m); }
}

export default mail